import api from './api';
import { HmgRole, HmgRoleFormData, ApiResponse, HmgPermission } from '../types';

export const roleService = {
  async getAll(search = '', is_active?: boolean): Promise<HmgRole[]> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (is_active !== undefined) params.append('is_active', is_active.toString());

    const response = await api.get<HmgRole[]>(`/hmg/roles?${params}`);
    return response.data;
  },

  async getActive(): Promise<HmgRole[]> {
    const response = await api.get<HmgRole[]>('/hmg/roles/active');
    return response.data;
  },

  async getById(id: number): Promise<HmgRole> {
    const response = await api.get<HmgRole>(`/hmg/roles/${id}`);
    return response.data;
  },

  async create(data: HmgRoleFormData): Promise<HmgRole> {
    const response = await api.post<HmgRole>('/hmg/roles', data);
    return response.data;
  },

  async update(id: number, data: HmgRoleFormData): Promise<HmgRole> {
    const response = await api.put<HmgRole>(`/hmg/roles/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/hmg/roles/${id}`);
  },

  async toggleActive(id: number): Promise<HmgRole> {
    const response = await api.patch<ApiResponse<HmgRole>>(`/hmg/roles/${id}/toggle-active`);
    return response.data.data!;
  },

  async getPermissions(id: number): Promise<HmgPermission[]> {
    const response = await api.get<HmgPermission[]>(`/hmg/roles/${id}/permissions`);
    return response.data;
  },

  async syncPermissions(id: number, permissionIds: number[]): Promise<{ message: string; permissions: HmgPermission[] }> {
    const response = await api.post<{ message: string; permissions: HmgPermission[] }>(
      `/hmg/roles/${id}/permissions/sync`,
      { permission_ids: permissionIds }
    );
    return response.data;
  },

  async addPermission(id: number, permissionId: number): Promise<{ message: string; permissions: HmgPermission[] }> {
    const response = await api.post<{ message: string; permissions: HmgPermission[] }>(
      `/hmg/roles/${id}/permissions/add`,
      { permission_id: permissionId }
    );
    return response.data;
  },

  async removePermission(id: number, permissionId: number): Promise<{ message: string; permissions: HmgPermission[] }> {
    const response = await api.delete<{ message: string; permissions: HmgPermission[] }>(
      `/hmg/roles/${id}/permissions/remove`,
      { data: { permission_id: permissionId } }
    );
    return response.data;
  },
};
